<header class="shadow-md relative transition-colors duration-300"
  [class.bg-faunago-dark]="appMode.isNature()" [class.text-white]="appMode.isNature()"
  [class.bg-faunago-yellow]="appMode.isGarbage()" [class.text-faunago-dark]="appMode.isGarbage()"
  [class.garbage-mode]="appMode.isGarbage()"
>
  <div class="container mx-auto flex items-center justify-between p-2 md:p-4">
    <div class="flex items-center">
      <a routerLink="" class="hidden xl:flex items-center">
        <img src="logo.svg" alt="FaunaGo Logo" class="h-10 w-auto" />
      </a>
    </div>

    <div class="hidden md:flex gap-3 xl:gap-8 items-center flex-1 ml-4 xl:ml-8">
      <!-- Mode Toggle (desktop: icons + text) -->
      @if (user$ | async) {
        <button
          (click)="appMode.toggle()"
          class="flex items-center rounded-full text-xs font-semibold transition-all cursor-pointer relative overflow-hidden"
          [class]="appMode.isNature()
            ? 'bg-white/15 border border-white/20'
            : 'bg-faunago-dark/15 border border-faunago-dark/20'"
        >
          <span
            class="flex items-center gap-1 px-2.5 py-1 rounded-full transition-all z-10"
            [class]="appMode.isNature()
              ? 'bg-white/25 text-white'
              : 'text-faunago-dark/40'"
          >
            <svg class="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="4" r="2"/><circle cx="18" cy="8" r="2"/><circle cx="20" cy="16" r="2"/><path d="M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10Z"/></svg>
            <span class="hidden xl:inline">Natură</span>
          </span>
          <span
            class="flex items-center gap-1 px-2.5 py-1 rounded-full transition-all z-10"
            [class]="appMode.isGarbage()
              ? 'bg-faunago-dark/25 text-faunago-dark'
              : 'text-white/40'"
          >
            <i class="pi pi-trash text-[10px]"></i>
            <span class="hidden xl:inline">Deșeuri</span>
          </span>
        </button>
      }
      <nav class="flex space-x-3 xl:space-x-6 items-center">
        <a [routerLink]="['/map']" [routerLinkActiveOptions]="{exact: true}"
          routerLinkActive="active-link"
          class="nav-link flex items-center gap-1 transition-colors"
          pTooltip="Harta" tooltipPosition="bottom"
        >
          <i class="pi pi-map"></i>
          <span class="nav-label hidden xl:inline">Harta</span>
        </a>
        @if (user$ | async; as user) {
        @if (appMode.isNature()) {
        <a [routerLink]="['/atlas']" routerLinkActive="active-link" class="nav-link flex items-center gap-1"
          pTooltip="Atlas" tooltipPosition="bottom"
        >
          <i class="pi pi-book"></i>
          <span class="nav-label hidden xl:inline">Atlas</span>
        </a>
        }
        <a [routerLink]="appMode.isNature() ? ['/observations'] : ['/garbage']"
          routerLinkActive="active-link"
          class="nav-link flex items-center gap-1 transition-colors"
          [pTooltip]="appMode.isNature() ? 'Observații' : 'Rapoarte'" tooltipPosition="bottom"
        >
          <i [class]="appMode.isNature() ? 'pi pi-eye' : 'pi pi-list'"></i>
          <span class="nav-label hidden xl:inline">{{ appMode.isNature() ? 'Observații' : 'Rapoarte' }}</span>
        </a>
        <a [routerLink]="['/events']"
          routerLinkActive="active-link"
          class="nav-link flex items-center gap-1 transition-colors"
          pTooltip="Evenimente" tooltipPosition="bottom"
        >
          <i class="pi pi-calendar"></i>
          <span class="nav-label hidden xl:inline">Evenimente</span>
        </a>
          @if (user.isStaff || user.isSuperuser || user.groups.includes('Admin') || user.groups.includes('admin')) {
            <a [routerLink]="['/admin']"
              routerLinkActive="active-link"
              class="nav-link flex items-center gap-1 transition-colors"
              pTooltip="Setări" tooltipPosition="bottom"
            >
              <i class="pi pi-cog"></i>
              <span class="nav-label hidden xl:inline">Setări</span>
            </a>
          }
          <a
            [routerLink]="appMode.isNature() ? ['/observations/new'] : ['/garbage/new']"
            [queryParams]="currentEventId() && appMode.isNature() ? { event: currentEventId() } : {}"
            class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md font-semibold text-sm hover:brightness-110 transition-all"
            [class]="appMode.isNature() ? 'bg-faunago-yellow text-faunago-dark' : 'bg-faunago-dark text-faunago-yellow'"
            [pTooltip]="appMode.isNature() ? 'Observație nouă' : 'Raport deșeuri nou'" tooltipPosition="bottom"
          >
            <i class="pi pi-plus text-xs"></i>
            <span class="hidden xl:inline">{{ appMode.isNature() ? 'Observație' : 'Raport deșeuri' }}</span>
          </a>
        }
      </nav>
    </div>

    <!-- Mobile Mode Toggle (icon only, top right) -->
    @if (user$ | async) {
      <button
        (click)="appMode.toggle()"
        class="md:hidden flex items-center rounded-full cursor-pointer p-0.5"
        [class]="appMode.isNature()
          ? 'bg-white/15 border border-white/20'
          : 'bg-faunago-dark/15 border border-faunago-dark/20'"
        [attr.aria-label]="appMode.isNature() ? 'Schimbă la Deșeuri' : 'Schimbă la Natură'"
      >
        <span
          class="flex items-center justify-center w-7 h-7 rounded-full transition-all"
          [class]="appMode.isNature()
            ? 'bg-white/25 text-white'
            : 'text-faunago-dark/40'"
        >
          <svg class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="4" r="2"/><circle cx="18" cy="8" r="2"/><circle cx="20" cy="16" r="2"/><path d="M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10Z"/></svg>
        </span>
        <span
          class="flex items-center justify-center w-7 h-7 rounded-full transition-all"
          [class]="appMode.isGarbage()
            ? 'bg-faunago-dark/25 text-faunago-dark'
            : 'text-white/40'"
        >
          <i class="pi pi-trash text-xs"></i>
        </span>
      </button>
    }

    <!-- Notifications + User Profile -->
    <div class="hidden md:flex items-center gap-4">
      @if (user$ | async) {
        <a [routerLink]="['/notifications']"
          routerLinkActive="active-link"
          class="nav-link relative transition-colors"
          pTooltip="Notificări"
        >
          <i class="pi pi-bell text-sm leading-none"></i>
          @if (notificationService.unreadCount() > 0) {
            <span class="absolute -top-1.5 -right-2.5 bg-red-500 text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1">
              {{ notificationService.unreadCount() > 99 ? '99+' : notificationService.unreadCount() }}
            </span>
          }
        </a>
      }
      @if (user$ | async; as user) {
        <a [routerLink]="['/profile']"
          routerLinkActive="active-link"
          class="nav-link flex items-center transition-colors"
        >
          @if (user.isSuperuser || user.isStaff || user.groups.includes('Admin') || user.groups.includes('admin')) {
            <i class="pi pi-shield text-sm leading-none mr-1" pTooltip="Admin"></i>
          }
          @if (user.groups.includes('Expert') || user.groups.includes('expert')) {
            <i class="pi pi-star-fill text-sm leading-none mr-1" pTooltip="Expert"></i>
          }
          @if (user.groups.includes('Basic') || user.groups.includes('basic') || (!user.isSuperuser && !user.isStaff && !user.groups.includes('Expert') && !user.groups.includes('expert'))) {
            <i class="pi pi-user text-sm leading-none mr-1" pTooltip="Basic"></i>
          }
          <span class="hidden xl:inline">{{ user.username }}</span>
        </a>
      } @else {
        <a [routerLink]="['/auth']" class="nav-link flex items-center transition-colors"
        >
          <i class="pi pi-sign-in mr-1" style="font-size: 14px"></i>
          <span>Login</span>
        </a>
      }
    </div>

  </div>
  @if (!connectivity.isOnline()) {
    <div class="bg-yellow-500 text-yellow-950 text-center py-1 text-xs font-medium flex items-center justify-center gap-2">
      <i class="pi pi-wifi-off text-[10px]"></i>
      <span>Fără conexiune — datele vor fi salvate local</span>
    </div>
  }
</header>

<!-- Mobile FABs -->
@if (!isOnCreatePage()) {
  @if (user$ | async; as user) {
    <!-- Notification floating button (only when unread) -->
    @if (notificationService.unreadCount() > 0) {
      <a
        [routerLink]="['/notifications']"
        class="md:hidden fixed bottom-36 right-4 z-[9999] w-10 h-10 rounded-full bg-white text-gray-700 shadow-lg flex items-center justify-center border border-gray-200"
        aria-label="Notificări"
      >
        <i class="pi pi-bell text-sm"></i>
        <span class="absolute -top-1 -right-1 bg-red-500 text-white text-[9px] font-bold rounded-full min-w-[16px] h-[16px] flex items-center justify-center px-0.5">
          {{ notificationService.unreadCount() > 9 ? '9+' : notificationService.unreadCount() }}
        </span>
      </a>
    }
    <!-- New observation/report FAB -->
    <a
      [routerLink]="appMode.isNature() ? ['/observations/new'] : ['/garbage/new']"
      [queryParams]="currentEventId() && appMode.isNature() ? { event: currentEventId() } : {}"
      class="md:hidden fixed bottom-20 right-4 z-[9999] w-14 h-14 rounded-full shadow-lg flex items-center justify-center hover:scale-110 transition-transform"
      [class]="appMode.isNature() ? 'bg-faunago-yellow text-faunago-dark' : 'bg-faunago-dark text-faunago-yellow'"
      [attr.aria-label]="appMode.isNature() ? 'Observație nouă' : 'Raport deșeuri nou'"
    >
      <i class="pi pi-plus text-xl"></i>
    </a>
  }
}
